import "./cotizador.css";

import { domain } from "../../Urls/Services/Api_urls";
import Cardcompra from "./Cards/cardcompra";
import React, { useEffect, useState } from "react";
import Cardcomprasin from "./Cards/cardcomprasin";
import CardTVPlan from "./Cards/CardTVPlan";
import { NavArrowLeft, NavArrowRight } from "iconoir-react";
import Slider from "react-slick";
const Cotizadortest = ({
  funcion,
  ruta,
  nombreButton,
  displaycall,
  setLoading,
  Loader,
  Parametro,
}) => {
  const type = Parametro;
  const grupo = window.sessionStorage.getItem("groups");

  const arreglo = [24, 54, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [data, setData] = useState([]);
  const [send, setSend] = useState("Triple");
  const [renderBtn, setRenderBtn] = useState(false);
  const [btnState, setBtnstate] = useState(" active");
  const [btnState1, setBtnstate1] = useState("");
  const [btnState2, setBtnstate2] = useState("");
  const [btnState3, setBtnstate3] = useState("");
  const [showTvButtons, setShowTvButtons] = useState(true);
  const [selectedTvType, setSelectedTvType] = useState("PLATAPLUS");
  const [currentTipoplan, setCurrentTipoplan] = useState("Triple");
  const [Estratoprice, setEstratoprice] = useState(1);
  
  // Estados para controlar la visibilidad de botones según disponibilidad de planes
  const [hasTriplePlans, setHasTriplePlans] = useState(false);
  const [hasDoblePlans, setHasDoblePlans] = useState(false);
  const [hasDuplaPlans, setHasDuplaPlans] = useState(false);
  const [hasInternetPlans, setHasInternetPlans] = useState(false);
  
  // Estados para controlar la visibilidad de botones de TV
  const [hasTvBasico, setHasTvBasico] = useState(false);
  const [hasTvPlata, setHasTvPlata] = useState(false);
  const [hasTvPlataPlus, setHasTvPlataPlus] = useState(false);

  const normalizeTipoplan = (value = "") => String(value).trim().toLowerCase();
  
  // Configuración para planes regulares
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: data.length > 4 ? 4 : data.length,
    slidesToScroll: 1,
    initialSlide: 0,
    dots: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1774,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 682,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };

  // Configuración específica para tarjetas de TV
  const tvSettings = {
    infinite: false,
    speed: 500,
    slidesToShow: data.length > 4 ? 4 : data.length,
    slidesToScroll: 1,
    initialSlide: 0,
    dots: true,
    arrows: true,
    variableWidth: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1774,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 682,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          arrows: true,
        },
      },
    ],
  };

  const precioEstrato = () => {
    let Estrato = window.sessionStorage.getItem("estrato");
    if (Estrato != null) {
      setEstratoprice(parseInt(Estrato));
    } else {
      setEstratoprice(1);
    }
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "#a3a3a3",
          borderRadius: "100px",
        }}
        onClick={onClick}
      >
        <NavArrowRight />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "#a3a3a3",
          borderRadius: "100px",
        }}
        onClick={onClick}
      >
        <NavArrowLeft />
      </div>
    );
  }

  const buttonrendertrp = () => {
    const hasTriplePlan = data.some((item) => item.tipoplan === "Triple");
    setRenderBtn(hasTriplePlan);
  };

  const onclicktriple = (e) => {
    if (btnState === "") {
      setSend("Triple");
      setCurrentTipoplan("Triple");
      setBtnstate(" active");
      setBtnstate1("");
      setBtnstate2("");
      setBtnstate3("");
      setShowTvButtons(true);
      setSelectedTvType("PLATAPLUS");
    }
  };

  const onclickDupla = (e) => {
    if (btnState1 === "") {
      setSend("Doble");
      setCurrentTipoplan("Doble");
      setBtnstate1(" active");
      setBtnstate("");
      setBtnstate2("");
      setBtnstate3("");
      setShowTvButtons(true);
      setSelectedTvType("PLATAPLUS");
    }
  };

  const onclickDuplaInt = (e) => {
    if (btnState2 === "") {
      setSend("Dupla");
      setCurrentTipoplan("Dupla");
      setBtnstate2(" active");
      setBtnstate("");
      setBtnstate1("");
      setBtnstate3("");
      setShowTvButtons(false);
    }
  };

  const onclickInt = (e) => {
    if (btnState3 === "") {
      setSend("Internet");
      setCurrentTipoplan("Internet");
      setBtnstate3(" active");
      setBtnstate("");
      setBtnstate1("");
      setBtnstate2("");
      setShowTvButtons(false);
    }
  };

  const onClickTvType = (type) => {
    setSelectedTvType(type);
  };

  const Descuentocard = (paquetes, index) => {
    const {
      tipoplan,
      nombre_plan,
      velocidad,
      json_valor,
      descuento,
      campaing,
      name_campaing,
      meses,
      megas,
      id__planes,
      descuento_valor,
      codigo_open,
      discount_months,
    } = paquetes;
    <li key="{data}"></li>;

    const estratoview = ["1-3", "4-6"];
    const estrato = estratoview[index % 2];

    const isUniversity = name_campaing === "CONVENIO";
    const cardColor = isUniversity ? "#DFF6DD" : "#ffffffff";
    const fontColor = "#303030";
    const personaLabel = isUniversity ? (
      <span className="text-colorprimary text-[1.1rem] font-bold">
        Plan universitario
      </span>
    ) : "Plan residencial";

    if (campaing != null) {
      return (
        <Cardcompra
          tipoplan={tipoplan}
          nombreplan={nombre_plan}
          velocidad={velocidad}
          precio_persona={json_valor.residencial}
          precio_empresa={json_valor.comercial}
          descuento={descuento}
          months={meses}
          discount_months={discount_months}
          descuento_valor={descuento_valor}
          codigo_open={codigo_open}
          id__planes={id__planes}
          megas={megas}
          estrato={Estratoprice}
          estratoview={estrato}
          color={cardColor}
          font={fontColor}
          personaLabel={personaLabel}
          buttondis={""}
          ruta={ruta}
          funcion={funcion}
          display={displaycall}
          nombreButton={nombreButton}
          setLoading={setLoading}
          Loader={Loader}
        />
      );
    } else {
      return (
        <Cardcomprasin
          nombreButton={nombreButton}
          ruta={ruta}
          funcion={funcion}
          display={displaycall}
          setLoading={setLoading}
          Loader={Loader}
          buttondis={""}
          estrato={Estratoprice}
          estratoview={estrato}
          tipoplan={tipoplan}
          nombreplan={nombre_plan}
          velocidad={velocidad}
          precio_persona={json_valor.residencial}
          precio_empresa={json_valor.comercial}
          codigo_open={codigo_open}
          id__planes={id__planes}
          color={cardColor}
          font={fontColor}
          personaLabel={personaLabel}
        />
      );
    }
  };

  useEffect(() => {
    const getData = () => {
      const user =
        window.sessionStorage.getItem("emailRes") ||
        window.sessionStorage.getItem("email");

      const stateVal =
        grupo === "vendedor_PAP" ||
        grupo === "facilitador_comercial" ||
        grupo === "Emcali_177"
          ? 2
          : 1;

      const params = new URLSearchParams({
        state: String(stateVal),
        user: user,
      }).toString();

      const url = `${domain}/portal/plan/?${params}`;

      fetch(
        url,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      )
        .then((data) => data.json())
        .then((data) => {
          setData(data);
          let datos = data;
          
          // Verificar disponibilidad de tipos de planes
          const hasTriple = datos.some(
            (item) => normalizeTipoplan(item.tipoplan) === "triple"
          );
          const hasDoble = datos.some(
            (item) => normalizeTipoplan(item.tipoplan) === "doble"
          );
          const hasDupla = datos.some(
            (item) => normalizeTipoplan(item.tipoplan) === "dupla"
          );
          const hasInternet = datos.some(
            (item) => normalizeTipoplan(item.tipoplan) === "internet"
          );
          
          setHasTriplePlans(hasTriple);
          setHasDoblePlans(hasDoble);
          setHasDuplaPlans(hasDupla);
          setHasInternetPlans(hasInternet);
          setRenderBtn(hasTriple);
          
          // Verificar disponibilidad de tipos de TV
          const hasBasico = datos.some((item) => {
            const planNameUpper = item.nombre_plan.toUpperCase();
            return (item.tipoplan === "Triple" || item.tipoplan === "Doble") &&
                   planNameUpper.includes("BASICO") && !planNameUpper.includes("PLATA");
          });
          
          const hasPlata = datos.some((item) => {
            const planNameUpper = item.nombre_plan.toUpperCase();
            return (item.tipoplan === "Triple" || item.tipoplan === "Doble") &&
                   planNameUpper.includes("PLATA") && 
                   !planNameUpper.includes("PLATAPLUS") &&
                   !planNameUpper.includes("PLATA PLUS");
          });
          
          const hasPlataPlus = datos.some((item) => {
            const planNameUpper = item.nombre_plan.toUpperCase();
            return (item.tipoplan === "Triple" || item.tipoplan === "Doble") &&
                   (planNameUpper.includes("PLATAPLUS") || planNameUpper.includes("PLATA PLUS"));
          });
          
          setHasTvBasico(hasBasico);
          setHasTvPlata(hasPlata);
          setHasTvPlataPlus(hasPlataPlus);
          
          // Seleccionar automáticamente el primer tipo de plan disponible
          if (hasTriple) {
            setSend("Triple");
            setCurrentTipoplan("Triple");
            setBtnstate(" active");
            setShowTvButtons(true);
            // Seleccionar el primer tipo de TV disponible
            if (hasPlataPlus) {
              setSelectedTvType("PLATAPLUS");
            } else if (hasPlata) {
              setSelectedTvType("PLATA");
            } else if (hasBasico) {
              setSelectedTvType("BASICO");
            }
          } else if (hasDoble) {
            setSend("Doble");
            setCurrentTipoplan("Doble");
            setBtnstate1(" active");
            setBtnstate("");
            setShowTvButtons(true);
            // Seleccionar el primer tipo de TV disponible
            if (hasPlataPlus) {
              setSelectedTvType("PLATAPLUS");
            } else if (hasPlata) {
              setSelectedTvType("PLATA");
            } else if (hasBasico) {
              setSelectedTvType("BASICO");
            }
          } else if (hasDupla) {
            setSend("Dupla");
            setCurrentTipoplan("Internet");
            setBtnstate2(" active");
            setBtnstate("");
            setShowTvButtons(false);
          } else if (hasInternet) {
            setSend("Internet");
            setCurrentTipoplan("Internet");
            setBtnstate3(" active");
            setBtnstate("");
            setShowTvButtons(false);
          }
        });
    };

    getData();
    precioEstrato();
  }, []);

  return (
    <div className="cti">
      <div style={{ height: 40 }} />
      <div className="row">
        <h3 className="Emcalititle">
          Paquetes <b>fibra óptica</b> Emcali con más <b>megas</b> que nunca.
        </h3>
        <hr className="underline" style={{ padding: "0", margin: "0" }}></hr>
        <div>
          <div style={{ height: 10 }} />
        </div>
        
        {/* Primera fila de botones */}
        <div className="options">
          {hasTriplePlans && (
            <div className="">
              <button
                className={`ini${btnState}`}
                name="Triple"
                value={"Triple"}
                onClick={onclicktriple}
              >
                Internet + Televisión + Telefonía
              </button>
            </div>
          )}
          {hasDoblePlans && (
            <div className="">
              <button
                className={`ini${btnState1} py-2`}
                name="Dupla"
                value={"Dupla"}
                onClick={onclickDupla}
              >
                Internet + Televisión
              </button>
            </div>
          )}
          {hasDuplaPlans && (
            <div className="">
              <button
                className={`ini${btnState2} py-2`}
                name="DuplaInt"
                value={"Dupla"}
                onClick={onclickDuplaInt}
              >
                Internet + Telefonía
              </button>
            </div>
          )}
          {hasInternetPlans && (
            <div className="">
              <button
                className={`ini${btnState3} py-2`}
                name="Internet"
                value={"Internet"}
                onClick={onclickInt}
              >
                Internet
              </button>
            </div>
          )}
        </div>

        {/* Segunda fila de botones - Tipos de TV */}
        {showTvButtons && (
          <div className="d-flex justify-content-center flex-wrap gap-3">
            {hasTvBasico && (
              <button
                className={`ini${selectedTvType === "BASICO" ? " active" : ""}`}
                onClick={() => onClickTvType("BASICO")}
                style={{ minWidth: '100px' }}
              >
                TV Básica
              </button>
            )}
            
            {hasTvPlata && (
              <button
                className={`ini${selectedTvType === "PLATA" ? " active" : ""}`}
                onClick={() => onClickTvType("PLATA")}
                style={{ minWidth: '100px' }}
              >
                TV Plata
              </button>
            )}
            
            {hasTvPlataPlus && (
              <button
                className={`ini${selectedTvType === "PLATAPLUS" ? " active" : ""}`}
                onClick={() => onClickTvType("PLATAPLUS")}
                style={{ minWidth: '100px' }}
              >
                TV Plata Plus
              </button>
            )}
          </div>
        )}
      </div>

      <div className="container">
        {showTvButtons ? (
          // Mostrar planes de TV con configuración específica de carrusel
          data.length > 0 ? (
            <div className="tv-carousel-container pb-4">
              <Slider {...tvSettings} key={`tv-${currentTipoplan}-${selectedTvType}-${Estratoprice}`}>
                {data
                  .filter((plan) => {
                    // Filtrar por tipo de plan (Triple o Doble con TV)
                    const isTipoplanMatch = 
                      (currentTipoplan === "Triple" && plan.tipoplan === "Triple") ||
                      (currentTipoplan === "Doble" && plan.tipoplan === "Doble");
                    
                    // Filtrar por tipo de TV basado en el nombre del plan
                    const planNameUpper = plan.nombre_plan.toUpperCase();
                    let isTvTypeMatch = false;
                    
                    if (selectedTvType === "BASICO") {
                      isTvTypeMatch = planNameUpper.includes("BASICO") && 
                                      !planNameUpper.includes("PLATA");
                    } else if (selectedTvType === "PLATA") {
                      isTvTypeMatch = planNameUpper.includes("PLATA") && 
                                      !planNameUpper.includes("PLATAPLUS") &&
                                      !planNameUpper.includes("PLATA PLUS");
                    } else if (selectedTvType === "PLATAPLUS") {
                      isTvTypeMatch = planNameUpper.includes("PLATAPLUS") || 
                                      planNameUpper.includes("PLATA PLUS");
                    }
                    
                    return isTipoplanMatch && isTvTypeMatch;
                  })
                  .map((plan, planIndex) => {
                    // Usar el estrato específico del usuario del formulario
                    const estratoUsuario = Estratoprice;
                    const estratoview = (estratoUsuario >= 1 && estratoUsuario <= 3) ? "1-3" : "4-6";
                    
                    const rango = { estrato: estratoUsuario, estratoview: estratoview };
                    
                    // Obtener precio para el estrato correspondiente
                    const precio = plan.json_valor.residencial[rango.estrato.toString()] || 
                                  plan.json_valor.residencial["1"];
                      
                    // Obtener precio con descuento si existe campaña
                    const precioDescuento = plan.campaing && plan.descuento_valor 
                      ? (plan.descuento_valor[rango.estrato.toString()] || plan.descuento_valor["1"])
                      : null;

                    // Extraer el tipo de TV del nombre del plan
                    const planNameUpper = plan.nombre_plan.toUpperCase();
                    let tipoTv = "basico";
                    if (planNameUpper.includes("PLATAPLUS") || planNameUpper.includes("PLATA PLUS")) {
                      tipoTv = "plata plus";
                    } else if (planNameUpper.includes("PLATA")) {
                      tipoTv = "plata";
                    } else if (planNameUpper.includes("BASICO")) {
                      tipoTv = "basico";
                    }

                    return (
                      <div className="item" key={`${plan.id__planes}-${planIndex}-${Estratoprice}`}>
                        <CardTVPlan
                          nombreplan={plan.nombre_plan}
                          velocidad={plan.velocidad}
                          tipoTv={tipoTv}
                          precio={precio}
                          precioDescuento={precioDescuento}
                          precio_persona={plan.json_valor?.residencial || {}}
                          precio_empresa={plan.json_valor?.comercial || {}}
                          descuento_valor={plan.descuento_valor || {}}
                          discount_months={plan.discount_months || null}
                          estrato={rango.estrato}
                          estratoview={rango.estratoview}
                          tipoplan={plan.tipoplan}
                          funcion={funcion}
                          nombreButton={nombreButton}
                          setLoading={setLoading}
                          Loader={Loader}
                          display={displaycall}
                          campaing={plan.campaing || false}
                          descuento={plan.descuento || null}
                          meses={plan.meses || null}
                          megas={plan.megas || 0}
                          name_campaing={plan.name_campaing || null}
                          fecha_inicio_descuento={plan.fecha_inicio_descuento || null}
                          fecha_fin_descuento={plan.fecha_fin_descuento || null}
                          id__planes={plan.id__planes || null}
                          codigo_open={plan.codigo_open || null}
                          ruta={ruta}
                          es_nuevo={plan.es_nuevo || false}
                        />
                      </div>
                    );
                  })}
              </Slider>
            </div>
          ) : (
            <div className="text-center py-5">
              <p>Cargando planes...</p>
            </div>
          )
        ) : (
          // Mostrar planes regulares
          data.length > 0 ? (
            <Slider {...settings} key={`regular-${send}-${Estratoprice}`}>
              {data
                .filter(
                  (plan) =>
                    normalizeTipoplan(send) === normalizeTipoplan(plan.tipoplan)
                )
                .map((plan) => {
                  // Usar el índice correcto según el estrato del usuario (0 para estrato 1-3, 1 para estrato 4-6)
                  const i = (Estratoprice >= 1 && Estratoprice <= 3) ? 0 : 1;
                  return <div className="item" key={`${plan.tipoplan}-${plan.id__planes}-${Estratoprice}`}>{Descuentocard(plan, i)}</div>;
                })}
            </Slider>
          ) : (
            <div className="text-center py-5">
              <p>Cargando planes...</p>
            </div>
          )
        )}
        <div style={{ height: 30 }} />
      </div>
    </div>
  );
};

export default Cotizadortest;
